/* Spruce dynamic email popup.
   Copy is resolved per product handle > product family > global by the behavr
   bandit (behavr-decide), so water enhancer, magnesium, electrolyte, bundle and
   editorial pages each get their own problem-agitation / curiosity-gap angle.
   Submissions go to popup-subscribe, which tags the Klaviyo profile with the
   funnel so post-signup flows can stay on-message. */
(function () {
  var CFG = window.SPRUCE_POPUP_CONFIG || {};
  var API = (CFG.api || '').replace(/\/$/, '');
  if (!API) return;

  var POPUP_ID = 'spruce-email-popup';
  var STORE_KEY = 'spruce_pop_v1';
  var SESSION_KEY = 'spruce_pop_sid';
  var COOLDOWN_CLOSE_HOURS = 12;   // soft close (X / esc / backdrop)
  var COOLDOWN_DECLINE_DAYS = 30;  // explicit "no thanks"
  var COOLDOWN_SIGNUP_DAYS = 180;

  var path = window.location.pathname;
  if (/\/(cart|checkout|account|challenge|tools)/.test(path)) return;
  if (/[?&]spruce_pop=off/.test(window.location.search)) return;

  var state = read(STORE_KEY) || {};
  var forced = /[?&]spruce_pop=1/.test(window.location.search);
  if (!forced && state.signedUp) return;
  // Dismissed recently: no auto-open, but the teaser tab stays available.
  var cooling = !forced && !!(state.until && Date.now() < state.until);


  var sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  var decision = null;
  var opened = false;
  var openedAt = 0;
  var root = null;
  var teaser = null;

  // Pageviews this session. The popup never interrupts the very first page a
  // visitor lands on unless they show intent (deep scroll or exit).
  var views = 1;
  try {
    views = (parseInt(sessionStorage.getItem('spruce_pop_views') || '0', 10) || 0) + 1;
    sessionStorage.setItem('spruce_pop_views', String(views));
  } catch (e) {}


  function read(k) {
    try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; }
  }
  function write(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }
  function remember(patch) {
    state = Object.assign({}, state, patch);
    write(STORE_KEY, state);
  }
  function val(el, fallback) {
    var c = decision && decision.chosen && decision.chosen[el];
    return (c && c.value) || fallback;
  }
  // A coherent whole-message block (eyebrow + headline + body from one angle)
  // wins over the older split elements so angles never get mixed.
  function block() {
    var c = decision && decision.chosen && decision.chosen.message;
    if (!c || !c.value) return null;
    try { return JSON.parse(c.value); } catch (e) { return null; }
  }
  function part(name, fallback) {
    var b = block();
    if (b && b[name]) return b[name];
    return val(name === 'eyebrow' ? 'eyebrow' : name, fallback);
  }

  function labelOf(el) {
    var c = decision && decision.chosen && decision.chosen[el];
    return (c && c.label) || null;
  }

  function post(fn, payload) {
    return fetch(API + '/' + fn, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: CFG.anonKey || '' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  // Dashboard funnel tracking (views / dismissals). Submissions are logged
  // server-side by popup-subscribe, so they are not repeated here.
  function track(event) {
    try {
      post('popup-event', {
        event: event,
        variant: (decision && decision.chosen && decision.chosen.message && decision.chosen.message.label) || 'A',
        product: CFG.handle || null,
        product_title: CFG.productTitle || null,
        popup_id: POPUP_ID,
        popup_name: 'Spruce email popup',
        page: window.location.pathname,
        timestamp: new Date().toISOString()
      }).catch(function () {});
    } catch (e) {}
  }

  function decide() {
    return post('behavr-decide', {
      popup_id: POPUP_ID,
      session_id: sessionId,
      page: window.location.pathname + window.location.search,
      referrer: document.referrer || null,
      utm_source: new URLSearchParams(window.location.search).get('utm_source'),
      category: CFG.category || null,
      returning: !!state.signedUp
    }).then(function (d) { decision = d || {}; return decision; });
  }

  function build() {
    root = document.createElement('div');
    root.className = 'spruce-pop';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Reveal a treat for your first Spruce order');
    root.innerHTML =
      '<div class="spruce-pop__card">' +
        '<div class="spruce-pop__media"' + (CFG.image ? ' style="background-image:url(' + CFG.image + ')"' : '') + '></div>' +
        '<div class="spruce-pop__body">' +
          '<p class="spruce-pop__eyebrow">' + part('eyebrow', '— PSST, THIRSTY? —') + '</p>' +
          '<h2 class="spruce-pop__sub">' + part('sub', 'We hid a treat<br/><em>in the fruit.</em>') + '</h2>' +
          '<div class="spruce-pop__copy">' + part('body', '<p>Pop your email in and we will reveal a little something for your first order.</p>') + '</div>' +
          '<form class="spruce-pop__form" novalidate>' +
            '<input class="spruce-pop__hp" type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0" />' +
            '<input class="spruce-pop__input" type="email" name="email" inputmode="email" autocomplete="email" required placeholder="Your email address" aria-label="Email address" />' +
            '<button class="spruce-pop__cta" type="submit">' + val('cta', 'Reveal my treat  →') + '</button>' +
          '</form>' +

          '<p class="spruce-pop__error" role="alert"></p>' +
          '<p class="spruce-pop__trust">' + val('trust', 'Worth it. Promise. Plus free shipping over £30.') + '</p>' +
          '<button class="spruce-pop__decline" type="button">No thanks, I drink enough water</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);

    root.querySelector('.spruce-pop__decline').addEventListener('click', function () { dismiss(true); });
    root.querySelector('form').addEventListener('submit', submit);
  }

  function open() {
    if (opened) return;
    if (!root) build();
    opened = true;
    openedAt = Date.now();
    document.documentElement.classList.add('spruce-pop-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () {
      var input = root.querySelector('.spruce-pop__input');
      if (input && window.matchMedia('(min-width: 750px)').matches) input.focus();
    }, 320);
    hideTeaser();
    remember({ seen: true });
    track('view');
  }


  function close() {
    if (!root) return;
    opened = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('spruce-pop-lock');
    showTeaser();
  }

  function dismiss(hard) {
    close();
    var ms = hard ? COOLDOWN_DECLINE_DAYS * 864e5 : COOLDOWN_CLOSE_HOURS * 36e5;
    remember({ until: Date.now() + ms });
    if (decision && decision.impression_id) {
      post('behavr-event', { impression_id: decision.impression_id, event: 'dismiss' }).catch(function () {});
    }
    track('dismiss');
  }

  function showTeaser() {
    if (teaser || state.signedUp) return;
    teaser = document.createElement('button');
    teaser.type = 'button';
    teaser.className = 'spruce-pop-teaser';
    teaser.textContent = 'Save up to 50%  →';
    teaser.addEventListener('click', function () { open(); });
    document.body.appendChild(teaser);
  }

  function hideTeaser() {
    if (teaser) { teaser.remove(); teaser = null; }
  }

  function submit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var input = form.querySelector('.spruce-pop__input');
    var btn = form.querySelector('.spruce-pop__cta');
    var err = root.querySelector('.spruce-pop__error');
    var email = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      err.textContent = 'Pop in a valid email and we will send it over.';
      input.focus();
      return;
    }
    err.textContent = '';
    btn.disabled = true;
    btn.textContent = 'Sending…';

    post('popup-subscribe', {
      email: email,
      category: CFG.category || 'global',
      product_handle: CFG.handle || null,
      page: window.location.pathname,
      angle: labelOf('message') || labelOf('sub') || labelOf('body') || null,
      impression_id: (decision && decision.impression_id) || null,
      hp: (form.querySelector('.spruce-pop__hp') || {}).value || '',
      fill_ms: openedAt ? Date.now() - openedAt : 0,
      variant_ids: decision && decision.chosen
        ? Object.keys(decision.chosen).map(function (k) { return decision.chosen[k].id; })
        : []
    }).then(function (res) {

      if (!res || res.error) throw new Error(res && res.error);
      remember({ signedUp: true, until: Date.now() + COOLDOWN_SIGNUP_DAYS * 864e5 });
      success();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = val('cta', 'Reveal my treat  →');
      err.textContent = 'That did not go through. Try again in a moment.';
    });
  }

  function success() {
    var body = root.querySelector('.spruce-pop__body');
    body.innerHTML =
      '<p class="spruce-pop__eyebrow">— YOU\'RE IN —</p>' +
      '<h2 class="spruce-pop__sub">Here\'s your<br/><em>15% off.</em></h2>' +
      '<span class="spruce-pop__code">HYDRATE15</span>' +
      '<div class="spruce-pop__copy"><p>Use it at checkout on your first order. We have emailed it over too, so it is not going anywhere.</p></div>' +
      '<button class="spruce-pop__cta" type="button" data-shop>Start shopping  →</button>' +
      '<p class="spruce-pop__trust">Free shipping over £30, or over £10 on subscriptions.</p>';
    body.querySelector('[data-shop]').addEventListener('click', close);
    hideTeaser();
  }

  function arm() {
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      open();
    }
    // Time on page: only from the second page of a session, so a fresh landing
    // is never interrupted before the visitor has seen the product.
    if (views > 1) setTimeout(fire, CFG.delay || 25000);
    // Scroll depth: real reading intent, not a first flick.
    window.addEventListener('scroll', function () {
      var d = document.documentElement;
      var pct = (d.scrollTop + window.innerHeight) / Math.max(1, d.scrollHeight);
      if (pct > 0.8) fire();
    }, { passive: true });

    // Desktop exit intent
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) fire();
    });
  }

  function start() {
    showTeaser();
    decide().then(function (d) {
      if (d && d.suppress && !forced) return;
      build();
      if (!cooling) arm();
    }).catch(function () {});
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
